<template>
  <div class="control-box">
    <v-btn
      class="play-and-pause"
      :control-style="true"
      @btnClick="on_play_pause"
    >
      <v-icon v-if="!isPause">pause</v-icon>
      <v-icon v-else>play_arrow</v-icon>
    </v-btn>
    <div class="process-box">
      <div class="process-bar-box">
        <span class="current" ref="currentTime">00:00</span>
        <div class="process-bar" ref="processBar"></div>
        <span class="duration" ref="duration">00:00</span>
      </div>
    </div>
  </div>
</template>

<script>
import "./index.scss";
import vAudio from "@/vendor/v-audio.min";
import Range from "@/vendor/range.min";
import { uuidv4 } from "utils/util";

export default {
  inject: ["data"],
  data() {
    this.VAudioObject = null;
    this.audioRange = null;
    this.isTap = false;
    this.playerId = uuidv4();
    return {
      isPause: true,
    };
  },
  mounted() {
    this.init_audio();

    this.$P.$on("pause-all-audio", this.pause);
  },
  beforeDestroy() {
    this.VAudioObject.destroy();
    this.audioRange.destroy();
    this.$P.$off("pause-all-audio", this.pause);
  },
  methods: {
    pause(playerId) {
      if (playerId === this.playerId) return;
      this.VAudioObject?.pause?.();
    },
    init_audio() {
      this.VAudioObject = new vAudio({
        src: this.data.lists[0].audioUri,
        autoPlay: false,
      });
      this.range_init();
      this.event_handle();
    },
    load_audio(link, autoPlay = false) {
      this.VAudioObject.load_audio(link, autoPlay);
    },
    on_play_pause() {
      this.VAudioObject?.toggle_play?.();
    },
    range_init() {
      this.audioRange = new Range({
        el: this.$refs.processBar,
        min: 0,
        max: 1000,
        step: 1,
        value: 0,
      });
    },
    update_current_time(time) {
      this.$refs.currentTime.innerHTML = this.VAudioObject.format_time(time);
    },
    on_watcher_update_handle(currentTime, percentage, duration, ended) {
      if (this.isTap) return;
      this.audioRange.set_value(percentage, true);
      this.update_current_time(currentTime);
    },
    event_handle() {
      this.audio_event_handle();
      this.audio_range_event_handle();
    },
    audio_range_event_handle() {
      let newPercentage = 0;
      this.audioRange
        .on("slideChange", (event, value, percentage, isManually) => {
          let currentTime = this.VAudioObject.get_duration()
            ? this.VAudioObject.get_duration() * percentage
            : 0;
          this.update_current_time(currentTime);
          if (isManually) return;

          //  拖拽时触发
          newPercentage = percentage;
        })
        .on("changeStart", (event) => {
          this.isTap = true;
        })
        .on("changeEnded", (event) => {
          this.isTap = false;
          this.VAudioObject.set_current_time(newPercentage, true);
          !this.VAudioObject.audio.paused && this.VAudioObject.play();
        });
    },
    audio_event_handle() {
      this.VAudioObject.on("loaded", (event, currentTime, duration) => {
        this.update_current_time(0);
        this.$refs.duration.innerHTML = this.VAudioObject.format_time(duration);
        this.VAudioObject.pause();
      })
        .on("pause", () => {
          this.isPause = true;
        })
        .on("play", () => {
          this.$P.$emit("pause-all-audio", this.playerId);
          this.isPause = false;
        })
        .on(
          "watcherUpdate",
          (event, currentTime, percentage, duration, ended) => {
            this.on_watcher_update_handle(
              currentTime,
              percentage,
              duration,
              ended
            );
          }
        );
    },
  },
};
</script>
